import { Component, OnInit } from '@angular/core';
import { DataService } from '../../services/data.service';
import { ClientService } from '../../services/api/client.service';
import { CONSTANTS } from '../../constants';
import { JqueryUtils } from '../../utils/jquery.utils';

import Chart from 'chart.js/auto';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  admin: any;
  completed_strategies: any = [];
  running_strategies: any = [];
  reports: any = {};
  strategies_total = 0.0;
  report_pnl = 0.0;
  selected_report: any = {};
  closeLegParams: any = {};
  overview_chart: any;
  report_types: any = {
    'this_week': { text: 'This Week' },
    'this_month': { text: 'This Month' },
    'this_year': { text: 'This Year' },
    'last_5_days': { text: 'Last 5 Days' },
    'last_10_days': { text: 'Last 10 Days' },
    'last_week': { text: 'Last Week' },
    'last_month': { text: 'Last Month' },
    'last_3_months': { text: 'Last 3 Months' },
    'last_6_months': { text: 'Last 6 Months' },
    'last_year': { text: 'Last Year' },
  };

  constructor(private clientService: ClientService, private dataService: DataService,
    private jq: JqueryUtils) { }

  ngOnInit(): void {
    this.admin = sessionStorage.getItem(CONSTANTS.COOKIE.IS_ADMIN);
    this.dataService.pageLoaded({name: CONSTANTS.URI_PATH.DASHBOARD});
    this.selected_report = this.report_types['this_week'];
    this.loadRunningPnL();
    this.loadOverview();
  }

  loadRunningPnL() {
    this.clientService.getStrategies({type:'all'}).subscribe((response: any) => {
      // response.completed = []
      // response.running = []
      this.completed_strategies = this.get_completed(response.completed);
      this.running_strategies = this.get_running(response.running);
    });
  }

  loadOverview() {
    this.clientService.getReport({type:'all'}).subscribe((response: any) => {
      this.reports = this.get_reports(response.reports);
      this.report_pnl = response.report_pnl;
      // this.reports = this.get_reports([]);
      // this.report_pnl = 1000;
      this.createChart();
    });
  }

  createChart() {
    if (this.overview_chart) {
      this.overview_chart.destroy();
    }
    const data = {
      labels: this.reports.labels,
      datasets: [{
        label: 'Profit/Loss',
        backgroundColor: (context: any) => {
          if (context.raw > 0) {
            return 'rgb(14, 243, 105)';
          } else if (context.raw < 0) {
            return 'rgb(243, 14, 14)';
          }
          return '#000000';
        },
        borderColor: (context: any) => {
          if (context.raw > 0) {
            return 'rgb(14, 243, 105)';
          } else if (context.raw < 0) {
            return 'rgb(243, 14, 14)';
          }
          return '#000000';
        },
        data: this.reports.data,
      }]
    };
    const options = {
      scales: {
        x: {
          barPercentage: 0.75,
          grid: {
            display: false
          },
        },
        y: {
          // beginAtZero: true,
          grid: {
            display: false
          }
        }
      }
    };
    const config: any = {
      type: 'bar',
      data: data,
      options: options
    };
    const chartItem: any = document.getElementById('marketingOverview');
    this.overview_chart = new Chart(chartItem, config);
  }

  get_completed(completed: any) {
    // completed = [{
    //   name: 'LRLR',
    //   legs: ['ce', 'pe'],
    //   ce: { strike: 42000, option_type: 'CE', position: 'sell', quantity: 25, entry: 100.00, exit: 79.5 },
    //   pe: { strike: 41000, option_type: 'PE', position: 'sell', quantity: 25, entry: 100.00, exit: 132.5 }
    // },
    // {
    //   name: 'ITM Buy',
    //   legs: ['ce', 'pe'],
    //   ce: { strike: 41000, option_type: 'CE', position: 'buy', quantity: 25, entry: 500.00, exit: 430 },
    //   pe: { strike: 42300, option_type: 'PE', position: 'buy', quantity: 25, entry: 500.00, exit: 650 }
    // }];
    completed.forEach((element: any) => {
      let spnl = 0.0;
      element.legs.forEach((e: any) => {
        let leg = element[e];
        leg.strike_ot = `${leg.strike} ${leg.option_type}`;
        leg.net_qty = 0;
        leg.pnl = (((leg.exit - leg.entry) * ((leg.position == 'sell') ? -1 : 1)) * leg.quantity);
        spnl += leg.pnl;
      });
      element.pnl = spnl;
    });
    return completed;
  }

  get_running(running: any) {
    // running = [
    //   {
    //     name: 'LRLR',
    //     legs: ['ce', 'pe'],
    //     ce: { strike: 42000, option_type: 'CE', position: 'sell', quantity: 25, entry: 100.00, exit: 150.00 },
    //     pe: { strike: 41000, option_type: 'PE', position: 'sell', quantity: 25, entry: 100.00 }
    //   },
    //   {
    //     name: 'ITM Buy',
    //     legs: ['ce', 'pe'],
    //     ce: { strike: 41000, option_type: 'CE', position: 'buy', quantity: 25, entry: 500.00 },
    //     pe: { strike: 42300, option_type: 'PE', position: 'buy', quantity: 25, entry: 500.00 }
    //   }
    // ];
    running.forEach((element: any) => {
      let spnl = 0.0;
      element.legs.forEach((e: any) => {
        let leg = element[e];
        leg.strike_ot = `${leg.strike} ${leg.option_type}`;
        leg.net_qty = `${(leg.position == 'buy') ? '' : '-'}${leg.quantity}`;
        leg.pnl = !leg.exit ? 0.0 : (((leg.exit - leg.entry) * ((leg.position == 'sell') ? -1 : 1)) * leg.quantity);
        spnl += leg.pnl;
      });
      element.pnl = spnl;
    });
    return running;
  }

  get_reports(reports: any) {
    // if (this.selected_report.text == 'This Week') {
    //   reports = [
    //     { date: '2023-05-15', pnl: 1000 },
    //     { date: '2023-05-16', pnl: -1000 },
    //     { date: '2023-05-17', pnl: 1000 },
    //     { date: '2023-05-18', pnl: -1000 },
    //     { date: '2023-05-19', pnl: 1000 },
    //   ];
    // } else {
    //   reports = [
    //     { date: '2023-05-02', pnl: 1000 },
    //     { date: '2023-05-03', pnl: -1000 },
    //     { date: '2023-05-05', pnl: 1000 },
    //     { date: '2023-05-08', pnl: -1000 },
    //     { date: '2023-05-09', pnl: 1000 },
    //     { date: '2023-05-10', pnl: -1000 },
    //     { date: '2023-05-11', pnl: 1000 },
    //     { date: '2023-05-12', pnl: -1000 },
    //     { date: '2023-05-15', pnl: 1000 },
    //     { date: '2023-05-16', pnl: -1000 },
    //     { date: '2023-05-17', pnl: 1000 },
    //     { date: '2023-05-18', pnl: -1000 },
    //     { date: '2023-05-19', pnl: 1000 },
    //   ];
    // }
    let report_data: any = { labels: [], data: [] }
    reports.forEach((element: any) => {
      report_data.labels.push(element.date);
      report_data.data.push(element.pnl);
    });
    return report_data;
  }

  getPnLClass(pnl: any) {
    if (pnl < 0) {
      return { 'text-danger': 1 };
    }
    return { 'text-success': 1 };
  }

  getPnLIconClass(pnl: any) {
    if (pnl < 0) {
      return { 'bi-caret-down-fill': 1, 'text-danger': 1 };
    }
    return { 'bi-caret-up-fill': 1, 'text-success': 1 };
  }

  getFormattedPnL(pnl: any) {
    let formatted_pnl = pnl.toLocaleString('en-IN', {minimumFractionDigits: 2})
    return `${pnl < 0 ? '' : '+' }${formatted_pnl}`;
  }

  getTotalPnl() {
    let total: any = 0.0;
    this.completed_strategies.forEach((element: any) => {
      total += element.pnl;
    });
    this.running_strategies.forEach((element: any) => {
      total += element.pnl;
    });
    return this.getFormattedPnL(total);
  }

  getPositionCloseIconClass(strategy_leg: any) {
    if (strategy_leg.entry && strategy_leg.exit) {
      strategy_leg.close = true;
      return { 'bi-x-circle-fill': 1, 'text-secondary': 1 }
    }
    strategy_leg.close = false;
    return { 'bi-x-circle-fill': 1, 'text-danger': 1 }
  }

  onCloseClick(strategy: any, leg: any) {
    if (!strategy[leg].close) {
      this.jq.openModal('closeLegConfirmationModal');
      this.closeLegParams = {
        close_leg_strategy: strategy,
        cls_ot: leg,
        selected_leg: leg.toUpperCase()
      };
    }
  }

  closeSelectedLeg(confirm: any, params: any) {
    if (confirm == 1) {
      this.clientService.closeLeg({}).subscribe((response: any) => {
        this.closeLegParams = {};
        this.jq.closeModal('closeLegConfirmationModal')
      });
    } else {
      this.closeLegParams = {};
      this.jq.closeModal('closeLegConfirmationModal')
    }
  }

  onItemSelected(selected_item: any) {
    this.selected_report = this.report_types[selected_item];
    this.loadOverview();
  }
}
